import type { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface ConfirmModalProps {
  show: boolean;
  title: string;
  children: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  cancelLabel?: string;
  submittingLabel?: string;
  confirmVariant?: "warning" | "danger" | "primary" | "success";
  isSubmitting?: boolean;
  hideConfirm?: boolean;
}

const ConfirmModal = ({
  show,
  title,
  children,
  onCancel,
  onConfirm,
  confirmLabel,
  cancelLabel = "Annuler",
  submittingLabel,
  confirmVariant = "primary",
  isSubmitting = false,
  hideConfirm = false,
}: ConfirmModalProps) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {cancelLabel}
        </button>
        {!hideConfirm ? (
          <button
            type="button"
            className={`btn btn-${confirmVariant}`}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? submittingLabel || confirmLabel : confirmLabel}
          </button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
